const Expertise = ({data}) => {

    const formatClassName = (string) => {
        return string.toLowerCase().replace(/\s/g, "");
    }
    
    return (
        <div className="component" id="expertise">
            <div className="container">
                <div className="content-area">
                    {
                        data?.acf?.skills?.map((item, index) => (
                            <div className="flip-card" key={index}>
                                <div className="flip-card-inner">
                                    <div className="flip-card-front">
                                        <img src={item.skill_logo} alt={item.skill_name} className={`logo ${formatClassName(item.skill_name)}`} />
                                        <p>{item.skill_name}</p>
                                    </div>
                                    <div className="flip-card-back"><p>{item.skill_percentage}%</p></div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default Expertise;